export const STEPPER_FORM_DATA_KEY = 'stepper-form-data'
export const RESET_PASSWORD_KEY = 'reset-password-data'
